import {
    ROLE_ADD,
    ROLE_APPROVE,
    ROLE_EDIT,
    ROLE_ITEM_DELETE_RESPONSE,
    ROLE_ITEM_SAVE_RESPONSE,
    ROLE_LIST_RESPONSE,
    ROLE_REJECT,
    ROLE_REMOVE,
    STAKEHOLDER_CANCEL_MODEL_UPDATE,
    STAKEHOLDER_FINISH_SAVING,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"

/*
  saveStatus can be "PUT", "PATCH", "DELETE", undefined (for
  untouched existing ones)
*/

export default (state = {}, action) => {
    const { type, data, role } = action

    switch (type) {
        case ROLE_LIST_RESPONSE:
            let roles = extractEntitiesFromData(data, state)

            const stakeholderID = action.searchCriteria.get("stakeholderID")

            return Object.keys(roles)
                .map(roleID => {
                    return {
                        ...roles[roleID],
                        stakeholderID
                    }
                })
                .reduce((newState, role) => {
                    return {
                        ...newState,
                        [role.id]: role
                    }
                }, roles)
        case ROLE_ITEM_SAVE_RESPONSE:
            return {
                ...state,
                [action.item.id]: { ...action.item }
            }
        case ROLE_ITEM_DELETE_RESPONSE:
            const newState = { ...state }
            delete newState[action.id]

            return newState
        case ROLE_REJECT:
            return {
                ...state,
                [role.id]: {
                    ...role,
                    approved: state[role.id].approved === false ? null : false,
                    saveStatus: "PATCH"
                }
            }
        case ROLE_APPROVE:
            return {
                ...state,
                [role.id]: {
                    ...role,
                    approved: state[role.id].approved === true ? null : true,
                    saveStatus: "PATCH"
                }
            }
        case ROLE_EDIT:
            return {
                ...state,
                [role.id]: {
                    ...state[role.id],
                    ...role,
                    saveStatus: "PATCH"
                }
            }
        case ROLE_ADD:
            return {
                ...state,
                [role.id]: {
                    ...role,
                    approved: true,
                    saveStatus: "PUT"
                }
            }
        case ROLE_REMOVE:
            // don't actually remove, just mark as status DELETE
            const previousSaveStatus =
                state[action.roleID] && state[action.roleID].saveStatus

            return {
                ...state,
                [action.roleID]: {
                    ...state[action.roleID],
                    // Handle the case of add, remove and save, in which case
                    // we have to make sure the status is null, not DELETE
                    saveStatus: previousSaveStatus === "PUT" ? null : "DELETE"
                }
            }
        case STAKEHOLDER_FINISH_SAVING:
        case STAKEHOLDER_CANCEL_MODEL_UPDATE:
            return Object.keys(state)
                .map(roleID => {
                    return {
                        ...state[roleID],
                        saveStatus: null
                    }
                })
                .reduce((newState, role) => {
                    return {
                        ...newState,
                        [role.id]: role
                    }
                }, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
